import { render, staticRenderFns } from "./ClubeVantagens.vue?vue&type=template&id=750e7274&scoped=true&"
import script from "./ClubeVantagens.vue?vue&type=script&lang=js&"
export * from "./ClubeVantagens.vue?vue&type=script&lang=js&"
import style0 from "./ClubeVantagens.vue?vue&type=style&index=0&id=750e7274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750e7274",
  null
  
)

export default component.exports